import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import TemplateStore from '../../../../stores/TemplateStore';
import useScreenHeight from '../../../../components/useScreenHeight';
import { Link } from 'react-router-dom';
import actionTypes from '../../../../actions/ActionTypes';
import {
  GetFormTypesICanEditTemplates,
} from '../../../../actions/TemplateActions';

const DefaultsSidebar = (props) => {
    const navigate = useNavigate();
    const [formTypes, setFormTypes] = useState([]);
    const [formTypeFilter, setFormTypeFilter] = useState(0);
    const screenHeight = useScreenHeight();

useEffect(() => {
  console.log('rebuild');
  let fts = TemplateStore.getFormTypes();

    TemplateStore.addChangeListener(onReceiveTemplateChange);
    if(fts.length === 0) {
      GetFormTypesICanEditTemplates();
    } else {
      setFormTypes(fts);
    }
    return () => {
        TemplateStore.removeChangeListener(onReceiveTemplateChange);
    }
},[]);

const onReceiveTemplateChange = () => {
    let lastChange = TemplateStore.getLastChange();

    if(lastChange === actionTypes.TemplateFormTypes)
    {

        let fts = TemplateStore.getFormTypes();
        setFormTypes(fts);
    }
}

const openNewDefault = () => {
    navigate('/Admin/Defaults/new');
}

const toggleFormGroup = (group) => {


  if(props.setFTFilter !== undefined)
  {
    if(group === 'all') {
        setFormTypeFilter(0);
        props.setFTFilter(0);
    } else {
        setFormTypeFilter(group.formTypeId);
        props.setFTFilter(group.formTypeId);
    }
  } else {
    navigate('/Admin/Defaults')
  }
}



return (
      <div
        className='d-flex flex-column p-3 text-white bg-dark'
        style={{ height: '100%', width: '274px' }}
      >
        <Link
          to='/Admin/Defaults'
          className='d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none'
        >
          <span className='fs-4'>
            <span style={{ color: '#4EE8E8' }}>
              <i className='fa-solid fa-pen-clip' />
            </span>
            {'   '}
            Defaults
          </span>
        </Link>
        <hr />


        <div
          className='coolScroll'
          style={{ maxHeight: screenHeight - 100, overflowY: 'scroll' }}
        >
          {formTypes.map((defaultGroup) => (
            <div key={defaultGroup.formTypeId}>
                <div
                    className={`${formTypeFilter === defaultGroup.formTypeId ? 'te-formtype-open-link2' : 'te-formtype-open-link'}`}
                    onClick={() => toggleFormGroup(defaultGroup)}
                    style={{ cursor: 'Pointer' }}
                    >
                    <i className='fa-regular fa-file-invoice' />{' '}
                    {defaultGroup.name}
                    </div>
            </div>
          ))}
        </div>

        <div
            className={`${formTypeFilter === 0 ? 'te-formtype-open-link2' : 'te-formtype-open-link'} mt-2`}
            onClick={() => toggleFormGroup('all')}
            style={{ cursor: 'Pointer' }}
          >
            <i className='fa-solid fa-file-invoice' />{' '}
            All Defaults
          </div>


        <hr />
        <button
          className='btn btn-primary btn-sm'
          onClick={openNewDefault}
        >
          New Default
        </button>



      </div>
    );


}

export default DefaultsSidebar;